<template>
  <div class="vol-page">
    <div class="vol-linear"></div>
    <div class="container">
      <div class="vol-banner">
        <span class="vol-event-name">志愿资讯</span>
        <img src="../../assets/volunteer/hearts.png" class="vol-hearts" />
      </div>
      <div class="content-wrap">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/home">首页</a></li>
            <li class="breadcrumb-item active" aria-current="page">志愿资讯</li>
          </ol>
        </nav>
        <div>
          <div class="safety-list">
            <div
              class="card"
              v-for="item in data.list"
              :key="item.paper_id"
              @click="toDetail(item)"
            >
              <div class="card-img-top">
                <img :src="item.cover" />
              </div>
              <div class="card-body">
                <div class="card-title">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <Pagination
            @change="pageChanged"
            :current="1"
            :pageSize="24"
            :hideOnSinglePage="true"
            :total="parseInt(data.total)"
            :showQuickJumper="false"
            :showTotal="false"
            placement="center"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import SearchBar from "@/components/SearchBar.vue";
import { paperList, paperDetail } from "@/network/API.js";
export default {
  components: {
    Pagination,
    SearchBar,
  },
  data() {
    return {
      data: {},
      pageNumber: 1,
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let data = await paperList({
        page: this.pageNumber,
        page_size: 24,
        show_total: 1,
        code: "volunteer",
      });
      this.data = data;
    },
    async toDetail(item) {
      if (item.feed_id && item.finder_user_name) {
        //视频号
        this.$toast("暂不支持查看视频号");
        return;
      }
      let detail = await paperDetail(item.paper_id);
      if (detail.offiaccount_url) {
        window.location.href = detail.offiaccount_url;
        // window.open(detail.offiaccount_url)
        return;
      }
      if (detail.paper_id) {
        this.$router.push({
          name: "VolunteerNewsDetail",
          params: {
            id: detail.paper_id,
          },
        });
      }
    },
    pageChanged(val) {
      this.pageNumber = val.page;
      this.getDataList();
    },
  },
};
</script>
<style>
.safety-banner {
  width: 100%;
  height: 300px;
  background: url(../../assets/safety/banner-safety.jpg) top center no-repeat;
  margin-bottom: -32px;
}

/* 选项卡 */

.nav-pills.nav-green .nav-link {
  margin: 0;
  margin-right: 20px;
  padding-left: 30px;
  padding-right: 30px;
  color: #333;
}

.nav-pills.nav-green .nav-link:hover {
  color: #1cc579;
}

.nav-pills.nav-green .nav-link.active {
  background: linear-gradient(107deg, #2fe091 0%, #1cc579 99%);
  color: #fff;
  border: none;
}
nav {
  position: relative;
}
.search-box {
  top: 10px;
}
</style>
